export default __webpack_public_path__ + "static/media/popup_close.96487f82.svg";